var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg56(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3453 42.5297H31.5293V37.7252H37.3453V31.9092H42.1498V37.7252H47.9658V42.5297H42.1498V48.3457H37.3453V42.5297Z",
    fill: "#34B778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1226 30.1392C21.4743 30.1392 24.1914 27.4221 24.1914 24.0703C24.1914 20.7186 21.4743 18.0015 18.1226 18.0015C14.7708 18.0015 12.0537 20.7186 12.0537 24.0703C12.0537 27.4221 14.7708 30.1392 18.1226 30.1392Z",
    fill: "#F26D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1226 46.0703C21.4743 46.0703 24.1914 43.3532 24.1914 40.0015C24.1914 36.6497 21.4743 33.9326 18.1226 33.9326C14.7708 33.9326 12.0537 36.6497 12.0537 40.0015C12.0537 43.3532 14.7708 46.0703 18.1226 46.0703Z",
    fill: "#F26D6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1226 62.0005C21.4743 62.0005 24.1914 59.2834 24.1914 55.9317C24.1914 52.5799 21.4743 49.8628 18.1226 49.8628C14.7708 49.8628 12.0537 52.5799 12.0537 55.9317C12.0537 59.2834 14.7708 62.0005 18.1226 62.0005Z",
    fill: "#F26D6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3638 37.9785C64.7155 37.9785 67.4326 35.2614 67.4326 31.9097C67.4326 28.5579 64.7155 25.8408 61.3638 25.8408C58.012 25.8408 55.2949 28.5579 55.2949 31.9097C55.2949 35.2614 58.012 37.9785 61.3638 37.9785Z",
    fill: "#F9B067"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3638 53.9092C64.7155 53.9092 67.4326 51.1921 67.4326 47.8403C67.4326 44.4886 64.7155 41.7715 61.3638 41.7715C58.012 41.7715 55.2949 44.4886 55.2949 47.8403C55.2949 51.1921 58.012 53.9092 61.3638 53.9092Z",
    fill: "#F9B067"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg56);
export default __webpack_public_path__ + "static/media/5-6.5c62f642b7db44cd15981dd7b6545515.svg";
export { ForwardRef as ReactComponent };